import * as EventListener from "../common/helpers/event-listener";
import csrfToken from "../common/helpers/csrf-token";

const contact = () => {
    EventListener.submit(
        "contactForm",
        null,
        "contactFormMessage",
        (formData, button, formError, formMessage, form) => {
            oc.ajax("Settings::onContact", {
                data: {
                    _token: csrfToken,
                    email: formData.get("email"),
                    phone: formData.get("phone"),
                    first_name: formData.get("first_name"),
                    last_name: formData.get("last_name"),
                    comment: formData.get("comment"),
                },
                loading: "#loader-line",
                complete: (result) => {
                    button.disabled = false;

                    if (result.status) {
                        form.reset();
                        formMessage.textContent = result.message;
                    }
                },
            });
        },
    );
};

contact();
